















import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { ImageLayer } from "@/model/document2/page/surface/design/layer/imageLayer";

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class ImageFlipController extends Vue 
{
    @Prop() layer! : ImageLayer;

    private changeHorizontalFlip()
    {
        this.changeLayerProperty("flipHorizontal", !this.layer.flipHorizontal, true, true);
    }

    private changeVerticalFlip()
    {
        this.changeLayerProperty("flipVertical", !this.layer.flipVertical, true, true);
    }

    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeLayerProperty", propertyName, value, isFinish, isOnce);
    }
}
